import { IMG } from "./site";

export const SERVICES = [
  {
    slug: "interieur",
    num: "01",
    label: "Intérieur",
    icon: "/brand/icon-0.png",
    title: "Peinture Intérieure & Décoration",
    lines: ["Peinture intérieure", "& décoration"],
    short: "Murs, plafonds, boiseries et effets décoratifs pour des pièces qui vous ressemblent.",
    image: IMG.salonAfter,
    detailImage: IMG.blueRoom,
    intro:
      "Un intérieur réussi commence par une préparation irréprochable. Rebouchage, ponçage, sous-couche adaptée : nous traitons chaque support avant d'appliquer des peintures haut de gamme, mates, satinées ou velours, pour un rendu tendu et durable.",
    items: [
      "Peinture murs & plafonds",
      "Laquage portes, boiseries & radiateurs",
      "Enduits décoratifs, béton ciré, stuc",
      "Effets chaulés & patines",
      "Conseil couleurs & harmonies",
      "Rénovation après sinistre",
    ],
  },
  {
    slug: "exterieur",
    num: "02",
    label: "Extérieur",
    icon: "/brand/icon-1.png",
    title: "Peinture Extérieure & Ravalement de façade",
    lines: ["Peinture extérieure", "& ravalement"],
    short: "Nettoyage, traitement et mise en peinture de façades pour protéger et valoriser votre bien.",
    image: IMG.facadeAfter,
    detailImage: IMG.houseCream,
    intro:
      "Votre façade est la première impression de votre maison. Nous diagnostiquons les fissures et l'humidité, nettoyons, traitons contre les mousses puis appliquons des revêtements respirants et imperméabilisants adaptés à chaque matériau.",
    items: [
      "Ravalement de façade complet",
      "Nettoyage haute pression & démoussage",
      "Traitement des fissures",
      "Peinture de volets, grilles & portails",
      "Imperméabilisation & hydrofuge",
      "Peinture de boiseries extérieures",
    ],
  },
  {
    slug: "revetements",
    num: "03",
    label: "Finitions",
    icon: "/brand/icon-2.png",
    icon2: "/brand/icon-3.png",
    title: "Revêtements de Murs & Sols",
    lines: ["Revêtements", "murs & sols"],
    short: "Toile de verre, papier peint, parquet, lino : des finitions nettes, posées dans les règles de l'art.",
    image: IMG.chambreAfter,
    detailImage: IMG.parquet,
    intro:
      "Du mur au sol, nous posons les revêtements qui transforment une pièce en quelques jours. Toile de verre pour des murs sains et renforcés, papiers peints panoramiques, parquets flottants ou collés, sols vinyles et linoléum.",
    items: [
      "Pose de toile de verre",
      "Papier peint & panoramiques",
      "Parquet flottant, collé ou massif",
      "Sols PVC, vinyle & linoléum",
      "Ragréage & préparation des sols",
      "Plinthes & finitions",
    ],
  },
];

export const STEPS = [
  ["Visite & conseil", "Nous venons sur place, écoutons votre projet et vous conseillons matériaux et teintes."],
  ["Devis détaillé sous 48h", "Un chiffrage clair, poste par poste, sans surprise ni frais cachés."],
  ["Préparation & protection", "Sols et mobilier protégés, supports rebouchés, poncés et traités."],
  ["Réalisation & finitions", "Application soignée, contrôles à chaque étape, respect des délais."],
  ["Réception & nettoyage", "Visite de fin de chantier ensemble, chantier rendu propre."],
];

export const getService = (slug) => SERVICES.find((s) => s.slug === slug);
